import { useNavigate } from "react-router-dom"
import { api } from "../../../../env"
import { useEffect, useState } from "react"
import Title from "../../../../components/Title";
import Input, { emailPattern, FormState, required, submitForm, useAreaInput, useTextInput } from "../../../../components/input";

const contactEmailsValidator = {
    func: (val) => val.split(', ').length == val.split(' ').length && val.split(', ').every(email => emailPattern.test(email)),
    error: "Emails must be valid and separated by comma"
}

export default function CompanyDetails({companyId}) {

    const navigate = useNavigate()

    const [company, setCompany] = useState(undefined)
    const [state, setState] = useState(FormState.VIEW)

    useEffect(() => {
        api.get(`companies/${companyId}`, { params: {page: 1, limit: 100}})
            .then(res => setCompany(res.data))
            .catch(err => navigate('..'))
    }, [companyId])

    const companyForm = {
        name: useTextInput("Name", "label", [required]),
        description: useAreaInput("Description", "description", []),
        emails: useAreaInput("Emails (sepparated with comma)", "email", [contactEmailsValidator])
    }

    const onEdit = () => {
        setState(FormState.UPDATE)
        companyForm.name._setValue(company.name)
        companyForm.description._setValue(company.description)
        companyForm.emails._setValue(company.contactEmails.join(', '))
    }

    const onClose = () => setState(FormState.VIEW)

    const onSave = () => {
        const info = submitForm(companyForm)
        if (!info) return
        const { emails, ...body } = info
        api.put(`companies/${companyId}`, {...body, contactEmails: emails.split(', ')})
            .then(res => {
                setCompany(res.data)
                onClose()
            })
            .catch(err => onClose())
    }

    return(<>
        <div className="flex space-between center gap-xs">
            <Title className={'v-spacer-xs'}>Details</Title>
            {state == FormState.VIEW && <button className="text showing" onClick={onEdit}>Edit</button>}
            {state == FormState.UPDATE && <div className="flex center gap-xs showing">
                <button className="outline" onClick={onClose}>Cancel</button>
                <button className="solid-accent" onClick={onSave}>Save</button>
            </div>}
        </div>
        <div className="card">
            {state == FormState.VIEW && <div className="data-grid">
                <p className="key-item">Name</p>
                <p className="value-item">{company?.name}</p>
                {company?.description && <>
                    <p className="key-item">Description</p>
                    <p className="value-item full">{company?.description}</p>
                </>}
                {company?.contactEmails && company.contactEmails.length > 0 && <>
                    <p className="key-item">Contact Emails</p>
                    <p className="value-item full">{company?.contactEmails?.join(', ')}</p>
                </>}
            </div>}
            {state == FormState.UPDATE && <div className="flex columns gap-xs">
                <Input state={companyForm.name}/>
                <Input state={companyForm.description}/>
                <Input state={companyForm.emails}/>
            </div>}
        </div>
    </>)

}